import easelAPI, {
  deleteOptions,
  getOptions,
  postOptions,
  EaselResponse,
  putOptions,
} from 'apis/helpers/easelAPI'

export const updateCurationArtworkStatus = async ({
  artworkId,
  direction,
}: Record<string, any>): Promise<EaselResponse> => {
  const options = {
    ...putOptions,
    body: JSON.stringify({
      artworkId,
      direction,
    }),
  }
  const json = await easelAPI.fetchValidateLoginJSON({
    name: 'updateCurationArtworkStatus',
    options,
    url: `/curation/artwork/status`,
  })
  return json
}

export const deleteCurationArtworkStatus = async ({
  artworkId,
  direction,
}: Record<string, any>): Promise<EaselResponse> => {
  const options = {
    ...deleteOptions,
    body: JSON.stringify({
      artworkId,
      direction,
    }),
  }
  const json = await easelAPI.fetchValidateLoginJSON({
    name: 'deleteCurationArtworkStatus',
    options,
    url: `/curation/artwork/status`,
  })
  return json
}

export const updateCurationArtworkIsSafe = async ({
  artworkId,
  isSafe,
}: Record<string, any>): Promise<EaselResponse> => {
  const options = {
    ...putOptions,
    body: JSON.stringify({
      artworkId,
      isSafe,
    }),
  }
  const json = await easelAPI.fetchValidateLoginJSON({
    name: 'updateCurationArtworkIsSafe',
    options,
    url: `/curation/artwork/isSafe`,
  })
  return json
}

export const fetchCurators = async (): Promise<EaselResponse> => {
  const options = getOptions
  const json = await easelAPI.fetchValidateLoginJSON({
    name: 'fetchCurators',
    options,
    url: `/curators`,
  })
  return json
}

export const fetchCurationArtistEmailForms = async ({
  artworkId,
  curatorId,
}: Record<string, any>): Promise<EaselResponse> => {
  const options = {
    ...postOptions,
    body: JSON.stringify({
      artworkId,
      curatorId,
    }),
  }
  const json = await easelAPI.fetchValidateLoginJSON({
    name: 'fetchCurationArtistEmailForms',
    options,
    url: `/curation/artist/emailForms`,
  })
  return json
}

export const postCurationArtistEmailSubmit = async ({
  email,
  message,
  subject,
}: Record<string, any>): Promise<EaselResponse> => {
  const options = {
    ...postOptions,
    body: JSON.stringify({
      email,
      message,
      subject,
    }),
  }
  const json = await easelAPI.fetchValidateLoginJSON({
    name: 'postCurationArtistEmailSubmit',
    options,
    url: `/curation/artist/emailSubmit`,
  })
  return json
}

export const fetchCurationBookmark = async (): Promise<EaselResponse> => {
  const options = getOptions
  const json = await easelAPI.fetchValidateLoginJSON({
    name: 'fetchCurationBookmark',
    options,
    url: `/curation/artwork/bookmark`,
  })
  return json
}

export const postCurationBookmark = async ({
  artworkId,
}: Record<string, any>): Promise<EaselResponse> => {
  const options = {
    ...postOptions,
    body: JSON.stringify({
      artworkId,
    }),
  }
  const json = await easelAPI.fetchValidateLoginJSON({
    name: 'postCurationBookmark',
    options,
    url: `/curation/artwork/bookmark`,
  })
  return json
}

export const fetchArtworkVotes = async (artworkId: string): Promise<Record<string, any>> => {
  const options = getOptions
  const json = await easelAPI.fetchValidateLoginJSON({
    name: 'fetchArtworkVotes',
    options,
    url: `/ops/curation/artwork/${artworkId}/votes`,
  })
  return json
}
